import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getReports = async (listId) => {
  const builder = new UrlBuilder(`/reports/get-reports/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const viewReport = async (payload) => {
  const builder = new UrlBuilder(`/reports/view-report`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
